import { useState } from 'react'

export interface TableSort { key: string; direction: 'asc' | 'desc' }
type SortValue = string | number | null | undefined

export function useTableSort(key: string, direction: TableSort['direction'] = 'asc') {
  const [sort, setSort] = useState<TableSort>({ key, direction })
  const toggleSort = (key: string) => setSort(current => ({ key, direction: current.key === key && current.direction === 'asc' ? 'desc' : 'asc' }))
  return { sort, setSort, toggleSort }
}

export function sortTableRows<T>(rows: readonly T[], sort: TableSort, columns: Record<string, (row: T) => SortValue>): T[] {
  const value = columns[sort.key]
  if (!value) return [...rows]
  return [...rows].sort((a, b) => {
    const left = value(a), right = value(b)
    const missingLeft = left == null || left === '' || (typeof left === 'number' && !Number.isFinite(left))
    const missingRight = right == null || right === '' || (typeof right === 'number' && !Number.isFinite(right))
    if (missingLeft || missingRight) return Number(missingLeft) - Number(missingRight)
    const compared = typeof left === 'number' && typeof right === 'number' ? left - right
      : String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' })
    return sort.direction === 'asc' ? compared : -compared
  })
}

export function matchesTableSearch(query: string, ...values: (string | null | undefined)[]) {
  return values.join(' ').toLocaleLowerCase().includes(query.trim().toLocaleLowerCase())
}
